import React, { useState,useEffect } from 'react';
import axios from 'axios'
import CommonVars from '../Component/CommonVars';
import { useParams } from 'react-router-dom';
import { useNumberInput,Input,Image,Box, Heading, Flex, VStack, HStack, Button,Link, useToast} from '@chakra-ui/react';


function CartDetailScreen(){
    const [carts,setCartDetail] = useState('')
    useEffect(() =>{
        getCartDetail()
     },[])
    const userid = useParams().userid
    const cartid = useParams().cartid
    // console.log (cartid)
    // console.log(userid)
    const { getInputProps, getIncrementButtonProps, getDecrementButtonProps } =
    useNumberInput({
      step: 1,
      defaultValue: 0,
      min: 0,
      max: 99
    })
    const inc = getIncrementButtonProps()
    const dec = getDecrementButtonProps()
    const input = getInputProps()

    const toast = useToast();
    const id = 'cartDetails-toast';

    const handleSubmit = (e) => {
        e.preventDefault();
    
        if(localStorage.getItem('token') !== null){
            const userid = localStorage.getItem('loggedInUserID');
            const token = localStorage.getItem('token');
    
            const qty = parseInt(input.value);
    
            const requestBody = {
                quantity: qty
            }
    
            console.log(requestBody)
            
            if(qty !== 0){
                axios.put(`${CommonVars.API_URL}/carts/${userid}/${cartid}`, requestBody,
                    { headers: { Authorization: `Bearer ${token}` } }
                )
                    .then(() => {
                        if(!toast.isActive(id)){
                            toast({
                                id,
                                title: 'Success!',
                                description: 'Cart successfully updated!',
                                status: 'success',
                                position: 'top',
                                duration: 3000,
                                isClosable: true,
                            });
                        }
    
                        setTimeout(() => {
                            window.location.replace('/carts');
                        }, 2000)
                    })
                    .catch((err) => {
                        console.log(err);
                        if(!toast.isActive(id)){
                            toast({
                                id,
                                title: 'Error!',
                                description: 'Update cart error!',
                                status: 'error',
                                position: 'top',
                                duration: 3000,
                                isClosable: true,
                            });
                        }
                    })
            } 
            else {
                if(!toast.isActive(id)){
                    toast({
                        id,
                        title: 'Error!',
                        description: 'Please enter quantity!',
                        status: 'error',
                        position: 'top',
                        duration: 3000,
                        isClosable: true,
                    });
                }
            }
        }
        else {
            window.location.replace('/login');
        }
    }

    const checkoutCart = (e) => {
        e.preventDefault();
        
        if(localStorage.getItem('token') !== null){
            const userid = localStorage.getItem('loggedInUserID');
            const token = localStorage.getItem('token');
    
            var qty = parseInt(input.value);
            
            if(qty == 0){
                qty = carts.quantity;
                axios.post(`${CommonVars.API_URL}/orders/${cartid}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                )
                    .then(() => {
                        if(!toast.isActive(id)){
                            toast({
                                id,
                                title: 'Success!',
                                description: 'Cart successfully updated!',
                                status: 'success',
                                position: 'top',
                                duration: 3000,
                                isClosable: true,
                            });
                        }
    
                        setTimeout(() => {
                            window.location.replace('/orders');
                        }, 2000)
                    })
                    .catch((err) => {
                        console.log(err);
                        if(!toast.isActive(id)){
                            toast({
                                id,
                                title: 'Error!',
                                description: 'Update cart error!',
                                status: 'error',
                                position: 'top',
                                duration: 3000,
                                isClosable: true,
                            });
                        }
                    })
            } 
        }
    }

    const getCartDetail = async() => {
        axios.get(`${CommonVars.API_URL}/carts/${userid}/${cartid}`)
        .then((res) =>{
            const CartDetail = res.data[0]
            setCartDetail(CartDetail)
        }).catch((err) =>{
            console.log(err)
        })
    }

    const aCartDetail = []
    aCartDetail.push(
        <Box w={'800px'}  shadow={'lg'}  roundedTop={'lg'} bg={'gray.100'}>
            <Flex>
                <Image boxSize={'300'} src={carts.image}/>
                <VStack marginInlineStart={'100'}>
                    <Box margin={'5'}  fontSize={'2xl'} fontWeight={'bold'}>
                        {carts.name}
                    </Box>
                    <Box   margin={'5'}  fontSize={'lg'} fontWeight={'semibold'}>
                        Description: {carts.description}
                    </Box>

                    <Box margin={'5'}  fontSize={'lg'} fontWeight={'semibold'}>
                      Quantity:  {carts.quantity}
                    </Box>
                    <Box  margin={'5'} fontSize={'lg'} fontWeight={'semibold'}>
                        Total: {carts.total}
                    </Box>
                    <HStack marginTop={'100'} maxW='450px'>
                        <Button bg={'white'} {...inc}>+</Button>
                        <Input bg={'white'} w={'20'} {...input} />
                        <Button bg={'white'} {...dec}>-</Button>
                    </HStack>
                    <Box >
                        <Button bg={'white'} onClick={handleSubmit}>
                            <Link href={`/carts`} >
                            Update Cart
                            </Link>
                        </Button>
                        <Button bg={'white'} onClick={checkoutCart}>
                            <Link>
                            Checkout
                            </Link>
                        </Button>
                    </Box>

                </VStack>
                

            </Flex>
            
        </Box>
    )
    return (
        <Box>
            <Heading fontWeight={'bold'}>
                Cart Details
            </Heading>
            <Box marginY={'150'} marginInline={'300'}>
                {aCartDetail}
            </Box>

        </Box>
    )
}   


export default CartDetailScreen;